// RevizyonUsulu.js — ORTAK BAŞVURU VERİSİ DEĞİŞİKLİK USULÜ: EKRANDA KURAL + ONAY + GEÇMİŞ (30 Eyl 2026)
//
// 🔑 Serkan (30 Eyl, CLAUDE.md C·6c): *"Süper admin bir değişim yapmadan önce revizyon bilgisini yayınlar ve
//    belirlenmiş tarihte ve saatte yapar"* · *"önceden mail ile yayınlar … force etmek sorun olabilir"* ·
//    *"ekleme de sorun olmaz, ayda bir liste yayınlanır ve belirtilen sürede değişiklik yapılır"* ·
//    *"bunu kurala yazacağız, unutuyoruz hep kuralları"* · *"tek özellik olsun, tek tip method."*
// Kural yalnız CLAUDE.md'de ve manuelde durursa unutulur → DÜZELTME penceresi kuralı YAZAR ve "duyuruldu"
// onayı işaretlenmeden hiçbir değişiklik düğmesi çalışmaz. Eklemede YOKTUR (ekleme serbest).
// Meydan (Airports) ve uçak tipi (AircraftTypes) AYNI bileşeni kullanır — tek tip, tek kaynak.
import { utcGunAySaat } from '../utcTarih';
import { withReason } from '../editReason';
import { zAlan } from './tasarim';

const C = { border:'var(--border)', t1:'var(--t1)', t2:'var(--t2)', t3:'var(--t3)', red:'var(--red)', amber:'var(--amber)' };
const th = { textAlign:'left', padding:'7px 10px', fontSize:9, color:C.t3, fontWeight:700,
             letterSpacing:1, borderBottom:`1px solid ${C.border}`, whiteSpace:'nowrap' };
const td = { padding:'7px 10px', fontSize:12, color:C.t1, borderBottom:`1px solid ${C.border}`,
             fontFamily:'var(--mono)', verticalAlign:'top' };

export const REVIZYON_KURALI =
  'Changes to shared reference data — correcting an airport or an aircraft type, closing, reopening or withdrawing it — '
  + 'are announced in the monthly revision list by e-mail and made at the time stated there. '
  + 'Adding a new airport or aircraft type needs no announcement.';
export const REVIZYON_ONAYI =
  'This change was announced in the monthly revision list by e-mail, and the stated time has come.';
export const REVIZYON_EKSIK = 'Confirm that this change was announced in the monthly revision list.';

/** Ekranda kural + zorunlu onay kutusu. */
export function RevizyonKurali({ onay, setOnay, testId }) {
  return (
    // Onay kapıdadır (REVIZYON_EKSIK) → zorunlu alan rengi: işaretlenene kadar amber, işaretlenince mavi (5 Eki 2026).
    <div data-testid={testId} {...zAlan({ fontSize:10, lineHeight:1.6, color:C.t2, marginBottom:12, padding:'8px 10px', borderRadius:4 },
                                        true, !!onay)}>
      <div data-testid={`${testId}-metin`} style={{ color:C.amber, fontWeight:700, marginBottom:6 }}>{REVIZYON_KURALI}</div>
      <label style={{ display:'flex', gap:8, alignItems:'flex-start', color:C.t1, cursor:'pointer' }}>
        <input type="checkbox" data-testid={`${testId}-onay`} checked={onay} onChange={e => setOnay(e.target.checked)} />
        <span>{REVIZYON_ONAYI}</span>
      </label>
    </div>
  );
}

const izDegeri = v => (v == null ? '—' : typeof v === 'object' ? JSON.stringify(v) : String(v));

/** HISTORY — superadmin_log satırları: tarih (UTC), kim, alan, eski, yeni, gerekçe. */
export function GecmisListesi({ satirlar, hata, kim, bosMetni, testId }) {
  if (hata) return <div data-testid={`${testId}-hata`} style={{ fontSize:11, color:C.red }}>HISTORY NOT READ — {hata}</div>;
  if (!satirlar.length) return <div data-testid={`${testId}-yok`} style={{ fontSize:10, color:C.t3 }}>{bosMetni}</div>;
  return (
    <table style={{ width:'100%', borderCollapse:'collapse' }} data-testid={testId}>
      <thead><tr>{['DATE (UTC)','BY','FIELD','OLD','NEW','REASON'].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
      <tbody>{satirlar.map((r, i) => (
        <tr key={i}>
          <td style={td}>{utcGunAySaat(r.at)}</td>
          <td style={td}>{kim(r.actor_id)}</td>
          <td style={td}>{r.field === 'RECORD_CREATED' ? 'ADDED' : r.field}</td>
          <td style={td}>{r.field === 'RECORD_CREATED' ? '—' : izDegeri(r.old_value)}</td>
          <td style={td}>{r.field === 'RECORD_CREATED' ? '—' : izDegeri(r.new_value)}</td>
          <td style={td}>{r.reason}</td>
        </tr>))}</tbody>
    </table>
  );
}

/**
 * Gerekçeli düzeltme — meydan ve uçak tipi AYNI yoldan yazar. Gerekçe istekle gider (x-edit-reason; tetikleyici
 * iz yazar). RLS satırı sessizce eleyebilir: dönen satır yoksa "kaydedildi" DENMEZ.
 * @returns {{ hata: string|null }}
 */
export async function gerekceliGuncelle({ tablo, anahtarKolon, anahtar, etiket, degisiklik, gerekce }) {
  let sb;
  try { sb = await withReason(String(gerekce || '').trim()); }
  catch (e) { return { hata: e.message }; }
  const { data, error } = await sb.from(tablo).update(degisiklik).eq(anahtarKolon, anahtar).select(anahtarKolon);
  if (error) return { hata: error.message };
  if (!data || !data.length) return { hata: `${etiket} was not updated — the database returned no row.` };
  return { hata: null };
}
